<template>
  <div class="order-refund">
    <!--标题-->
    <div class="breadcrumb">申请订单扣费</div>
    <div class="rg-cn">
      <h3 class="dialog-title">
        <p><span></span>平台信息</p>
      </h3>
      <div class="dialog-content">
        <el-form ref="form" label-width="150px" :model="refundInfo" :rules="rules">
          <el-form-item label="平台号：">
            <span>{{ refundInfo.order.storeCode }}</span>
          </el-form-item>
          <el-form-item label="平台名称：">
            <span>{{ refundInfo.order.storeName }}</span>
          </el-form-item>
          <el-form-item label="实付总价：">
            <span>{{ refundInfo.order.priceReal }}</span>
          </el-form-item>
          <el-form-item label="订单扣费金额：" prop="totalPrice" v-if="refundInfo.refundType !== 'REBATE'">
            <el-input v-model="refundInfo.totalPrice" v-if="!refundId" type="number"></el-input>
            <span v-else>{{ refundInfo.totalPrice }}</span>
          </el-form-item>
          <el-form-item label="订单返款金额：" prop="totalPrice" v-else>
            <el-input v-model="refundInfo.totalPrice" v-if="!refundId" type="number"></el-input>
            <span v-else>{{ refundInfo.totalPrice }}</span>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input v-model="refundInfo.remark" v-if="!refundId"></el-input>
            <span v-else>{{ refundInfo.remark }}</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <order-item-component ref="orderItemRef" :orderNo="orderNo"></order-item-component>
    <div class="remaining-sum">
      <el-button type="primary" v-if="$hasPermission('oms:admin:orderRefund:apply') && !refundId" @click="deduction" round>申请扣费 </el-button>
      <el-button type="primary" v-if="$hasPermission('oms:admin:orderRefund:audit') && refundId && refundInfo.auditStatus === 'APPLY'" @click="dialogAudit = true" round v-preventReClick>审核通过
      </el-button>
      <el-button v-if="$hasPermission('oms:admin:orderRefund:audit') && refundId && refundInfo.auditStatus === 'APPLY'" @click="auditRefund('REJECTED')" round v-preventReClick> 审核拒绝 </el-button>
      <el-button type="primary" v-if="refundInfo.refundType === 'REBATE' || refundInfo.refundType === 'EXPRESS_FEE'" @click="$router.go(-1)" round v-preventReClick> 返回 </el-button>
    </div>
    <!-- 余额不足 -->
    <el-dialog :close-on-click-modal="false" title="操作提示" :visible.sync="dialogSuccess" width="30%" :append-to-body="true" :custom-class="'dialog-success'">
      <div class="content">
        <i class="el-icon-error"></i> 余额不足，请充值
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogSuccess = false">取消</el-button>
        <el-button size="small" type="primary" @click="dialogSuccess = false" v-preventReClick>确定</el-button>
      </span>
    </el-dialog>
    <!-- 审核弹窗 -->
    <el-dialog :close-on-click-modal="false" title="操作提示" :visible.sync="dialogAudit" width="30%" :append-to-body="true" :custom-class="'dialog-success'">
      <div class="content"> 是否审核通过 </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogAudit = false">取消</el-button>
        <el-button size="small" type="primary" @click="auditRefund('AUDITED')" v-preventReClick>确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { refundAmount, getOrderRefund, auditRefund } from '@/api/refund'
import { userQueryByUserId } from '@/api/crm'
import { getByStoreIds } from '@/api/epay'
import OrderItemComponent from '../../../components/OrderItem/index.vue'
export default {
  name: 'express-fee',
  components: { OrderItemComponent },
  data () {
    return {
      loading: false,

      orderNo: this.$route.query.orderNo,
      refundId: this.$route.query.refundId,
      refundInfo: {
        order: {
          storeCode: this.$route.query.storeCode,
          storeName: this.$route.query.storeName,
          priceReal: this.$route.query.priceReal
        },
        totalPrice: '',
        remark: ''
      },
      rules: {
        totalPrice: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      },
      dialogSuccess: false, // 申请余额不足提示弹窗
      dialogAudit: false, // 审核弹窗
      storeId: null // 平台ID
    }
  },
  created () {
    this.refundId && this.getOrderRefund()
    this.getUserQueryByUserId()
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    // 用户信息
    getUserQueryByUserId () {
      userQueryByUserId(this.$route.query.userId).then(res => {
        if (res.data.success) this.storeId = res.data.data.storeId
      })
    },
    deduction () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        if (this.loading) return
        if (this.refundInfo.totalPrice < 0) {
          this.$message.error('订单扣费金额不能小于0')
          return
        }
        // 我的余额
        this.loading = true
        getByStoreIds(this.storeId).then(res => {
          if (res.data.success) {
            console.log(res.data)
            // "VPAY_ACCOUNT": "充值余额",
            // "VPAY_BONUS": "虚拟余额",
            // "VPAY_SETTLE": "结算余额"
            let balances = res.data.data.balances
            let maxNum = Math.max(balances.ACCT.balance * 1 + res.data.standbyCreditLine * 1, balances.BONUS.balance * 1, balances.SETTLE.balance * 1)
            if (this.refundInfo.totalPrice > maxNum) {
              this.dialogSuccess = true
              return
            }
            refundAmount(this.orderNo, {
              refundType: 'EXPRESS_FEE',
              storeCode: this.$route.query.storeCode,
              totalPrice: this.refundInfo.totalPrice,
              remark: this.refundInfo.remark
            }).then(res => {
              if (res.data.success === true) {
                this.$notify({
                  title: '操作成功',
                  message: '申请扣费成功',
                  type: 'success'
                })
                this.$router.go(-1)
              }
            })
          }
        }).finally(() => {
          let timer = setTimeout(() => {
            this.loading = false
            clearTimeout(timer)
          }, 500)
        })
      })
    },
    getOrderRefund () {
      getOrderRefund(this.refundId).then(res => {
        if (res.data.success) {
          console.log(res.data, 'res.data')
          this.refundInfo = res.data.data
        }
      })
    },
    auditRefund (auditStatus) {
      // 我的余额
      if (this.loading) return
      this.loading = true
      getByStoreIds(this.storeId).then(res => {
        if (res.data.success) {
          console.log(res.data)
          // "VPAY_ACCOUNT": "充值余额",
          // "VPAY_BONUS": "虚拟余额",
          // "VPAY_SETTLE": "结算余额"
          let balances = res.data.data.balances
          let state = null
          // 定单返款（返款到充值余额）
          if (this.refundInfo.refundType === 'REBATE') {
            state = 'VP_ACCT'
          } else {
            if (balances.ACCT.balance * 1 + res.data.data.standbyCreditLine * 1 > this.refundInfo.totalPrice * 1) {
              state = 'VP_ACCT'
            } else if (balances.BONUS.balance * 1 > this.refundInfo.totalPrice * 1) {
              state = 'VP_BONUS'
            } else if (balances.SETTLE.balance * 1 > this.refundInfo.totalPrice * 1) {
              state = 'VP_SETTLE'
            } else {
              console.log('没有钱')
              this.dialogAudit = false
              // 审核通过的时候
              if (auditStatus == 'AUDITED') {
                this.dialogSuccess = true
                return
              }
            }
          }
          auditRefund({
            auditStatus: auditStatus,
            refundId: this.refundId,
            paymentChannel: state || 'VP_ACCT'
          }).then(res => {
            if (res.data.success) {
              this.$notify({
                title: '操作成功',
                message: '审核成功',
                type: 'success'
              })
              this.$router.go(-1)
            }
          })
        }
      }).finally(() => {
        let timer = setTimeout(() => {
          this.loading = false
          clearTimeout(timer)
        }, 500)
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.dialog-title {
  margin-bottom: 15px;
  height: 78px;
  background: inherit;
  background-color: rgba(250, 250, 250, 1);
  position: relative;

  p {
    line-height: 78px;
    padding-left: 50px;

    span {
      position: relative;
      top: -2px;
      display: inline-block;
      background: #409eff;
      width: 7px;
      height: 18px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
}

.remaining-sum {
  overflow: hidden;

  @{deep} .el-button.is-round {
    float: right;
    margin: 20px 50px 0 0;
  }
}

/deep/ .el-dialog__body {
  .content {
    font-size: 18px;
  }

  .el-icon-error {
    font-size: 18px;
    color: #ff0000;
  }
}
</style>
